(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.setHeaderHeightBound = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      // ✅ imk artimiausią wrapperį, o ne pirmą per visą document
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      // ✅ saugiai susirask predictive-search tik savo viduje
      this.predictiveSearch = this.querySelector('predictive-search');

      // ✅ Update header height ir kai layout keičiasi (pvz. mygtukas, fontai, appai)
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightBound);

      // ✅ Labai stabilu: ResizeObserver automatiškai pataiso --header-height
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      const innerHeader = this.querySelector('header');
      if (innerHeader) this.resizeObserver.observe(innerHeader);

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();

      // Keep transparent state at initial top position on pages using transparent header.
      this.syncInitialHeaderState = () => {
        if (!this.header) return;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (scrollTop <= 24) this.header.classList.remove('scrolled-past-header');
      };
      this.syncInitialHeaderState();
      window.setTimeout(this.syncInitialHeaderState, 0);
      window.setTimeout(this.syncInitialHeaderState, 140);
      window.addEventListener('load', this.syncInitialHeaderState);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia('(max-width: 990px)').removeEventListener('change', this.setHeaderHeightBound);

      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      const target = this.header || this.closest('.section-header');
      if (!target) return;

      document.documentElement.style.setProperty('--header-height', `${target.offsetHeight}px`);
    }

    createObserver() {
      if (!this.header) return;

      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (!this.headerBounds) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      if (!this.header) return;

      // ✅ svarbiausia: null-check + close tik jei egzistuoja
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class StaticHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.header) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (scrollTop <= 24) this.header.classList.remove('scrolled-past-header');
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
